import { useQueryClient } from 'react-query';
import { DigitalFormsQueries } from '@frontend/api-digital-forms';
import { useNavigate } from '@frontend/weave-router';
import { useCommonActionSubscriptions } from './actions/use-common-actions-subscriptions';
import { useNotificationActionSubscription } from './actions/use-notification-action-subscription';
import { useNotification } from './use-notification';

export const useFormNotification = () => {
  const queryClient = useQueryClient();
  const { create, remove } = useNotification<'form-submission-new'>();
  const navigate = useNavigate();
  useCommonActionSubscriptions('form-submission-new');

  useNotificationActionSubscription('form-submission-new', 'view', ({ notification }) => {
    queryClient.invalidateQueries(DigitalFormsQueries.endpointKeys.submissionsList);
    navigate({
      to: '/forms/submissions',
      search: {
        listType: 'inbox',
        subCategory: 'all',
        locationId: notification.payload.locationId,
        submissionId: notification.payload.submissionId,
      },
    });
  });
  return {
    create,
    remove,
  };
};
